import Types from './Types';

const INITIAL_STATE = {
    announcements: [],
    announcement: {},
    isLoading: false,
    count: ''
};

export default function announcements(state = INITIAL_STATE, action) {
    const { type, payload } = action;
    switch (type) {
        case Types.GET_ANNOUNCEMENTS_SUCCESS: {
            // Handle both cases: payload.data (wrapped) or payload (direct array)
            const announcementsData = Array.isArray(payload.data) ? payload.data : (Array.isArray(payload) ? payload : []);
            return {
                ...state,
                announcements: announcementsData,
                count: announcementsData.length
            };
        }

        case Types.EDIT_ANNOUNCEMENT_SUCCESS: {
            let data = payload.data;
            if (!data || !data.id) {
                return state; // Invalid data, return current state
            }
            const announcements = [...state.announcements];
            let idx = -1;
            announcements.forEach((item, index) => {
                if (item.id === data.id) {
                    idx = index;
                    return;
                }
            });

            if (idx >= 0) {
                announcements[idx] = data;
            }
            return {
                ...state,
                announcements: announcements
            };
        }

        // create
        case Types.CREATE_ANNOUNCEMENT_SUCCESS: {
            const data = payload.data.data;
            let newArray = state.announcements.slice();
            let index = state.announcements.length + 1;
            newArray.splice(index, 0, data);
            return {
                ...state,
                announcements: newArray
            };
        }
        case Types.ADD_ANNOUNCEMENTS_LOADING: {
            return {
                ...state,
                isLoading: payload
            };
        }

        case Types.DELETE_ANNOUNCEMENT_SUCCESS: {
            const newAnnouncements = state.announcements.filter((item) => item.id !== payload);
            return {
                ...state,
                announcements: newAnnouncements
            };
        }

        case Types.ACTIVATE_ANNOUNCEMENT_SUCCESS: {
            let data = payload.data;
            if (!data || !data.id) {
                return state; // Invalid data, return current state
            }
            const announcements = [...state.announcements];
            let idx = -1;
            announcements.forEach((item, index) => {
                if (item.id === data.id) {
                    idx = index;
                    return;
                }
            });

            if (idx >= 0) {
                announcements[idx] = data;
            }
            return {
                ...state,
                announcements: announcements
            };
        }
        default: {
            return state;
        }
    }
}

